export default class AjaxForm {
	constructor(form) {
		this.form = form;
		this.feedback = form.querySelector('[data-form-feedback]');
		this.form.addEventListener('submit', this.submit.bind(this));
	}

	resetFeedback() {
		this.feedback.innerHTML = '';
		this.feedback.classList.remove('is-success', 'is-error', 'is-active');
	}

	addFeedback(message, classes) {
		this.feedback.classList.add(...classes);
		this.feedback.innerHTML = message;
	}

	displaySuccess(data) {
		this.resetFeedback();
		this.form.reset();
		this.addFeedback(data.data.message, ['is-success', 'is-active']);
	}

	displayFailure(error) {
		error = error ?? 'Er ging iets mis';
		console.log(error);
		this.resetFeedback();
		this.addFeedback(error, ['is-error', 'is-active']);
	}

	submit(e) {
		e.preventDefault();

		if (this.isSubmitting) {
			return; // Prevent multiple submit requests
		}

		this.isSubmitting = true;

		fetch(this.form.action, {
			method: 'POST',
			body: new FormData(this.form),
		})
			.then((response) => response.json())
			.then((data) => this.displaySuccess(data))
			.catch((error) => this.displayFailure(error))
			.finally(() => (this.isSubmitting = false));
	}
}
